import React from 'react';
import { Link } from 'react-router-dom';
import ChatWidget from './ChatWidget';

const Footer = () => {
  return (
    <footer className="bg-black text-white pt-20 pb-8 font-sans relative">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        
        {/* Top Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          {/* Left Column: Branding & Contact */}
          <div className="lg:col-span-4 lg:pr-8">
            <Link to="/" className="inline-block mb-6">
              <div className="flex items-center">
                <div className="flex items-center justify-center bg-[#dc343b] text-white p-1.5 rounded-lg mr-3 shadow-md">
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='currentColor'>
                    <path d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z'/>
                  </svg>
                </div>
                <span className="text-xl font-extrabold tracking-tight text-white uppercase">
                  NETROOTX BILLING
                </span>
              </div>
            </Link>
            <p className="text-sm text-gray-400 mb-8 leading-relaxed pr-4">
              Building the digital infrastructure for the next generation of MSMEs and industry titans in India.
            </p>
            
            {/* Social Icons */}
            <div className="flex gap-4 mb-8">
              {['twitter', 'linkedin', 'github', 'instagram'].map((social) => (
                <a key={social} href="#" className="flex items-center justify-center w-10 h-10 rounded-full border border-gray-800 hover:border-gray-500 transition-colors">
                  <span className="sr-only">{social}</span>
                  <div className="w-4 h-4 bg-gray-400 rounded-sm"></div> {/* Placeholder for actual SVG icon */}
                </a>
              ))}
            </div>

            {/* Contact Details */}
            <div className="space-y-3 text-[13px] text-gray-400">
              <div className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                support@netrootxbilling.com
              </div>
              <div className="flex items-center gap-3 hover:text-white transition-colors cursor-pointer">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                +91 800 123 4567
              </div>
              <div className="flex items-start gap-3 hover:text-white transition-colors cursor-pointer pt-1">
                <svg className="w-4 h-4 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                100 Feet Road, Indiranagar, Bengaluru, Karnataka 560038
              </div>
            </div>
          </div>

          {/* Right Columns: Links */}
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8">
            
            {/* Sitemap */}
            <div>
              <h3 className="text-[15px] font-semibold text-[#6366f1] mb-6 tracking-wide">Sitemap</h3>
              <ul className="space-y-4">
                {['Digital Ledger', 'Invoicing Software', 'Inventory Management', 'Staff Attendance', 'Services', 'Our Team', 'Hire Developers'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-[13px] text-gray-400 hover:text-white transition-colors">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h3 className="text-[15px] font-semibold text-[#6366f1] mb-6 tracking-wide">Legal</h3>
              <ul className="space-y-4">
                {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-[13px] text-gray-400 hover:text-white transition-colors">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Socials */}
            <div>
              <h3 className="text-[15px] font-semibold text-[#6366f1] mb-6 tracking-wide">Socials</h3>
              <ul className="space-y-4">
                {['Twitter', 'LinkedIn', 'Instagram', 'GitHub'].map((item) => (
                  <li key={item}>
                    <a href="#" className="text-[13px] text-gray-400 hover:text-white transition-colors">{item}</a>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800/60 pt-8 pb-4 flex flex-col sm:flex-row items-center justify-between text-xs text-gray-500 gap-4">
          <p>© 2026 Khatabook Inc. All rights reserved.</p>
          <p>Designed & Engineered in India IN</p>
        </div>

      </div>

      {/* Interactive Chat Widget */}
      <ChatWidget />

    </footer>
  );
};

export default Footer;
